import * as Sentry from '@sentry/react';
import { excludeGraphQLFetch } from 'apollo-link-sentry';
import { App } from 'app';
import { OpenApp } from 'common/components/OpenApp';
import { SentryBoundary } from 'error/SentryBoundary';
import { LoginWrapper } from 'utility/components/LoginWrapper';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import FluentUITheme from 'theme';
import { QueryParamProvider } from 'use-query-params';
import { ApolloWrapper } from 'utility/components/ApolloWrapper';
import { loadConfig } from './config';
import { setupIcons } from 'utility/icons';
import { Auth0ProviderWithRedirect } from 'utility/components/Auth0ProviderWithRedirect';
import { AppToaster } from 'utility/components/AppToaster';

import './index.css';
import { AcceptInvitation } from 'utility/components/AcceptInvitation';

setupIcons();

loadConfig().then((config) => {
  if (!config) throw new Error('Configuration file not found');

  if (config.sentry) {
    Sentry.init({
      dsn: config.sentry.dsn,
      environment: config.sentry.env,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: config.sentry.sampleRate ?? 0,
      beforeBreadcrumb: excludeGraphQLFetch,
      release: import.meta.env.VITE_BUILD_VERSION,
    });
  }

  const rootElement = document.getElementById('root');
  if (rootElement) {
    const root = createRoot(rootElement);

    root.render(
      <OpenApp>
        <BrowserRouter>
          <QueryParamProvider ReactRouterRoute={Route}>
            <Auth0ProviderWithRedirect
              domain={config.auth0.domain}
              clientId={config.auth0.clientId}
              authorizationParams={{
                redirect_uri: window.location.origin,
                audience: config.auth0.audience,
              }}
            >
              <ApolloWrapper>
                <FluentUITheme>
                  <AppToaster />
                  <SentryBoundary>
                    <Switch>
                      <Route
                        path="/invitation"
                        exact
                        component={AcceptInvitation}
                      />
                      <Route path="*">
                        <LoginWrapper>
                          <App />
                        </LoginWrapper>
                      </Route>
                    </Switch>
                  </SentryBoundary>
                </FluentUITheme>
              </ApolloWrapper>
            </Auth0ProviderWithRedirect>
          </QueryParamProvider>
        </BrowserRouter>
      </OpenApp>
    );
  }
});
